<div class="p-6 max-w-7xl mx-auto">

  <!-- HEADER BANNER -->
  <div class="mb-6 rounded-xl px-8 py-6" style="background: var(--color-action);">
    <h2 class="text-xl font-semibold text-white">Interactive Guides</h2>
    <p class="mt-1 text-sm text-white/80">
      Step-by-step interactive guides to help you get the most out of Colobbo.
    </p>
  </div>


  <!-- LOADING SKELETON -->
  @if (loading) {
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      @for (i of [1,2,3,4,5,6,7,8]; track i) {
        <div
          class="flex flex-col bg-white border rounded-lg shadow-sm animate-pulse overflow-hidden">
          <div class="w-full h-36 bg-gray-200"></div>
          <div class="p-5">
            <div class="w-8 h-8 bg-gray-200 rounded mb-3"></div>
            <div class="h-4 bg-gray-200 rounded w-2/3 mb-2"></div>
            <div class="h-3 bg-gray-100 rounded w-1/3 mb-2"></div>
            <div class="h-3 bg-gray-100 rounded w-full mb-1"></div>
            <div class="h-3 bg-gray-100 rounded w-4/5 mb-4"></div>
            <div class="border-t border-gray-200 my-3"></div>
            <div class="h-8 bg-gray-200 rounded-md w-full"></div>
          </div>
        </div>
      }
    </div>
  }

  <!-- EMPTY STATE -->
  @if (!loading && filteredLinks().length === 0) {
    <div
      class="flex flex-col items-center justify-center py-24 text-center">
      <div class="w-14 h-14 rounded-full bg-gray-100 flex items-center justify-center mb-4">
        <mat-icon class="text-gray-400 text-[28px]" svgIcon="c:search-slash"></mat-icon>
      </div>
      <p class="text-gray-700 font-semibold">No guides found</p>
      <p class="text-gray-400 text-sm mt-1">Try a different search or category</p>
    </div>
  }

  <!-- GRID -->
  @if (!loading && filteredLinks().length > 0) {
    <div
      class="flex flex-wrap justify-center gap-6">
      @for (link of filteredLinks(); track link; let i = $index) {
        <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -- pre-existing pattern; accessibility tracked under COL-37 -->
        <div
          class="relative flex flex-col bg-white border rounded-lg shadow-sm hover:shadow-md transition cursor-pointer overflow-hidden w-64"
          (click)="openGuide(link)"
          >
          <!-- THUMBNAIL -->
          <img
            [src]="link.thumbnail || ''"
            alt=""
            class="w-full h-52 object-cover"
            />
            <!-- CARD BODY -->
            <div class="flex flex-col p-5 flex-1">
              <!-- LOGO + TITLE ROW -->
              <div class="flex items-start gap-2 mb-2">
                <img
                  src="assets/images/colobbo_logo_mini.svg"
                  alt="Colobbo"
                  class="w-6 h-6 flex-shrink-0 object-contain mt-0.5"
                  />
                  <h3 class="font-semibold text-gray-900 text-sm leading-snug">
                    {{ link.name }}
                  </h3>
                </div>
                <!-- SEPARATOR -->
                <div class="mt-auto mb-4 border-t border-gray-200"></div>
                <!-- ACTION BUTTON -->
                <button
                  type="button"
                  class="w-full py-2 text-sm font-medium rounded-md transition !bg-[var(--color-button-quiet)] text-[var(--color-text)] hover:!bg-[var(--color-button-quiet-hover)] flex items-center justify-center gap-1.5"
                  (click)="openGuide(link); $event.stopPropagation()"
                  >
                  <mat-icon class="text-[18px] leading-none" svgIcon="c:play"></mat-icon>
                  Open Guide
                </button>
              </div><!-- /CARD BODY -->
            </div>
          }
        </div>
      }

    </div>
